import { useRef, useState } from "react";
import Autocomplete from "./Autocomplete";
import List from "./List.js";
import { controlOptions } from "../util/reducer";
import { Mui, MuiIcons } from '@osu/react-ui'
import ResetDefaults from "./ResetDefaults.js";
import { cardActionsSx } from "../styles/responsiveness.js";
import Validator from "./Validator.js";
import useLinks from "../hooks/useLinks.js";

const IconHeading = ({ heading, Icon, variant = 'h4', className: cls }) => {
  let className = 'display-flex align-items-center margin-y-2'
  if(cls) className += ` ${cls}`
  return <Mui.Typography className={className} variant={variant}>
  {heading} <Icon color="secondary" className="margin-left-2" />
</Mui.Typography>
}

function Form({ autocompleteRef }) {
  const [modalOpen, setModalOpen] = useState(false);
  const { preferencesState, updateLinks, onSubmit, onReset, saveDisabled, errorMessage, infoMessage, successMessage, isLoading, isSuccess } = useLinks()
  const alertRef = useRef();

  return (
    <Validator alertRef={alertRef} isLoading={isLoading} errorMessage={errorMessage} infoMessage={infoMessage} successMessage={successMessage}>
      <IconHeading heading="Organize" Icon={MuiIcons.SwapVert} />
      <Mui.Divider className="margin-top-1" />
      <List
        list={preferencesState?.list ?? []}
        updateLinks={updateLinks}
        lastAction={preferencesState?.lastAction}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <IconHeading heading="Add to List" Icon={MuiIcons.Add} />
      <Autocomplete
        autocompleteRef={autocompleteRef}
        sortedLinks={preferencesState?.list ?? []}
        onAdd={(links = []) => {
          updateLinks({
            type: controlOptions.add,
            links: links,
          });
        }}
      />
      <Mui.Divider className="margin-bottom-1" />
      <Mui.CardActions sx={cardActionsSx} className="padding-x-0">
        <ResetDefaults
          open={modalOpen}
          setOpen={setModalOpen}
          onSubmit={() => {
            onReset()
            setModalOpen(false);
          }}
        />
        <Mui.Button disabled={saveDisabled} onClick={onSubmit} startIcon={<MuiIcons.Save />} variant="contained">Save Preferences</Mui.Button>
      </Mui.CardActions>
    </Validator>
  );
}

export default Form;
